import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Donate } from '../Api/Donate';


export const fetchDonateHistoryThunk = createAsyncThunk(
    'donateHistory/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await Donate.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)


const initialState = {
    status: "pending",
    data: [],
}

export const donateHistorySlice = createSlice({
    name: 'donateHistory',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        },
    },
    extraReducers: {
        [fetchDonateHistoryThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchDonateHistoryThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [fetchDonateHistoryThunk.rejected]: (state, action) => {
            state.status = "error"
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus, resetState } = donateHistorySlice.actions

export default donateHistorySlice.reducer